import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hero", "thumbnail"]

  select(event) {
    const thumbnail = event.currentTarget
    const hero = this.heroTarget

    hero.classList.add("opacity-0")

    setTimeout(() => {
      hero.src = thumbnail.src
      hero.alt = thumbnail.alt
      hero.classList.remove("opacity-0")
    }, 150)

    this.thumbnailTargets.forEach(t => t.classList.remove("ring-2", "ring-sage-600"))
    thumbnail.classList.add("ring-2", "ring-sage-600")
  }
}
